import React from "react";
import { Route, Routes } from "react-router-dom";
import Protected from "./protected";
import Login from "../component/user/login";
import Signup from "../component/user/signup";
import LandingPage from "../component/landingpage";
import VerifyEmailOtp from "../component/user/verifyotpemail";
import ForgetPassword from "../component/user/forgetpassword";
import CreatePassword from "../component/user/createpassword";
import ChangesPassword from "../component/user/changepassword";
import ForgotPasswordOtp from "../component/user/forgetpasswordotp";
import { Getprofile } from "../redux/apiservice";
import GetProfile from "../component/user/getprofile";
import Welcome from "../component/welcome";
// import Register from "./component/design";
import Demo from "../component/user/demo";
import ProtectedRoute from "./protectedroute";
import Bonus from "../component/bonus";
import ChatLayout from "../layout/chat-layout";
import Dashboardlayout from "../layout/dashboard-layout";
import Myaccount from "../component/dashboard/pages/myaccount";
import Mywallet from "../component/dashboard/pages/mywallet";
import Chat from "../component/chat-dashboard/chatmain";
import Termspolicy from "../component/dashboard/pages/terms";
import DeleteAccount from "../component/user/deleteaccount";
import Privacypolicy from "../component/dashboard/pages/privacypolicy";

function Router() {
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <Protected>
              <LandingPage />
            </Protected>
          }
        />
        <Route
          path="/login"
          element={
            <Protected>
              <Login />
            </Protected>
          }
        />
        <Route
          path="/terms"
          element={
            <Protected>
              <Termspolicy />
            </Protected>
          }
        />
        <Route
          path="/privacy"
          element={
            <Protected>
              <Privacypolicy/>
            </Protected>
          }
        />
        <Route
          path="/signup"
          element={
            <Protected>
              <Signup />
            </Protected>
          }
        />
        <Route
          path="/verifyotpemail"
          element={
            <Protected>
              <VerifyEmailOtp />
            </Protected>
          }
        />
        <Route
          path="/forget"
          element={
            <Protected>
              <ForgetPassword />
            </Protected>
          }
        />
        <Route
          path="/deleteaccount"
          element={
              <Protected>
              <DeleteAccount />
            </Protected>
          }
        />
        <Route
          path="/forgetpasswordotp"
          element={
            <Protected>
              <ForgotPasswordOtp />
            </Protected>
          }
        />
        <Route path="/passwordreset" element={<CreatePassword />} />
        <Route
          path="/change"
          element={
            <Protected>
              <ChangesPassword />
            </Protected>
          }
        />
        <Route
          path="/getprofile"
          element={
            <Protected>
              <GetProfile />
            </Protected>
          }
        />
        <Route path="/demo" element={<Demo />} />
        <Route
          path="/welcome"
          element={
            <ProtectedRoute>
              <Welcome />
            </ProtectedRoute>
          }
        />
        <Route
          path="/bonus"
          element={
            <ProtectedRoute>
              <Bonus />
            </ProtectedRoute>
          }
        />
        <Route
          path="/chat"
          element={
            <ProtectedRoute>
              <ChatLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/chatmain"
          element={
            <ProtectedRoute>
              <Chat />
            </ProtectedRoute>
          }
        />
        <Route path="/dashboard" element={ <ProtectedRoute><Dashboardlayout /></ProtectedRoute>} />
        <Route path="myaccount" element={<ProtectedRoute><Myaccount /></ProtectedRoute>} />
        <Route path="wallet" element={<ProtectedRoute><Mywallet /></ProtectedRoute>} />
      </Routes>
    </>
  );
}

export default Router;
